module.exports = __webpack_public_path__ + "static/img/footR2.9237952.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footR2.png
// module id = OkTn
// module chunks = 0